import { useState, useEffect, useRef } from 'react';
import useGoogleMapsApi from './useGoogleMapsApi';

const useGoogleMaps = (options?: google.maps.MapOptions) => {
  const google = useGoogleMapsApi(
    process.env.REACT_APP_GOOGLE_MAPS_RETAIL_TOKEN ?? ''
  );

  const ref = useRef<HTMLElement>(null);

  const [map, setMap] = useState<google.maps.Map>();

  useEffect(() => {
    if (!google || !ref) {
      return;
    }

    setMap(new google.maps.Map(ref.current, options));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [google, ref]);

  return { ref, map, google };
};

export default useGoogleMaps;
